import gardening2 from "./serviceImages/gardening2.jpeg";
import plumbing2 from "./serviceImages/plumbing2.jpeg";
import electric2 from "./serviceImages/electric2.jpeg";
import carpet2 from "./serviceImages/carpet2.jpeg";
import hvac2 from "./serviceImages/hvac.jpeg";
import ceiling2 from "./serviceImages/ceiling2.jpeg";
import curtain2 from "./serviceImages/curtain2.jpeg";
import fire2 from "./serviceImages/fire2.jpeg";
import flooring2 from "./serviceImages/flooring2.jpeg";
import mechanic2 from "./serviceImages/mechanic2.jpeg";
import pest2 from "./serviceImages/pest2.jpeg";
import water2 from "./serviceImages/water2.jpeg";
import lift2 from "./serviceImages/lift2.jpeg";
import gate2 from "./serviceImages/gate2.jpeg";
import power2 from "./serviceImages/power2.jpeg";
import quality2 from "./serviceImages/quality2.jpeg";
import inventory2 from "./serviceImages/inventory2.jpeg";
import car1 from "./serviceImages/car1.jpeg";
import car2 from "./serviceImages/car2.jpeg";
import car3 from "./serviceImages/car3.jpeg";
import YardOutlinedIcon from "@mui/icons-material/YardOutlined";
import PlumbingOutlinedIcon from "@mui/icons-material/PlumbingOutlined";
import FlashOnOutlinedIcon from "@mui/icons-material/FlashOnOutlined";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import HouseboatOutlinedIcon from "@mui/icons-material/HouseboatOutlined";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PestControlOutlinedIcon from "@mui/icons-material/PestControlOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ElevatorIcon from "@mui/icons-material/Elevator";
import AirIcon from "@mui/icons-material/Air";

import FenceIcon from "@mui/icons-material/Fence";

import PowerIcon from "@mui/icons-material/Power";

import FactCheckIcon from "@mui/icons-material/FactCheck";
import InventoryIcon from "@mui/icons-material/Inventory";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import BusinessIcon from "@mui/icons-material/Business";

const serviceItems = [
  {
    img: "https://images.pexels.com/photos/7728651/pexels-photo-7728651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    img2: gardening2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Gardening",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <YardOutlinedIcon />,
  },
  {
    img: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    img2: plumbing2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Plumbing",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <PlumbingOutlinedIcon />,
  },

  {
    img: "https://images.pexels.com/photos/8005368/pexels-photo-8005368.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    img2: electric2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Electric",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <FlashOnOutlinedIcon />,
  },
  {
    img: "https://icleaninglimitedhome.files.wordpress.com/2020/04/beaa4-office_carpet_cleaning_1582285071_prev.jpg",
    img2: carpet2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Interior works",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <CleaningServicesOutlinedIcon />,
  },
  {
    img: "https://d33wubrfki0l68.cloudfront.net/a875f1328070517eb42c3e377cea3459241bdd3b/18717/en-us/assets/images/blog/cost-guide/hvac-repair-full.jpg",
    img2: hvac2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "HVAC",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <AirIcon />,
  },
  {
    img: "https://insights.workwave.com/wp-content/uploads/2020/05/moping-floor-and-cleaning-railing-picture-id944633842.jpg",
    img2: carpet2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "House Keeping & Cleaning services",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <CleaningServicesOutlinedIcon />,
  },
  {
    img: "https://lirp.cdn-website.com/fe1fc9be/dms3rep/multi/opt/Gilbert+Drywall+Repair+-+Ceiling+Repair+2-938w.jpg",
    img2: ceiling2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Ceiling, Flooring and Roofing",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <ConstructionOutlinedIcon />,
  },
  {
    img: "https://cdn.fantasticservices.com/wp-content/uploads/2016/11/Curtain-cleaning-technician.png",
    img2: curtain2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Curtain",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <WindowOutlinedIcon />,
  },
  {
    img: "https://volenesolutions.com/images/fire-safty.jpg",
    img2: fire2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Fire and Safety Management",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <LocalFireDepartmentOutlinedIcon />,
  },
  {
    img: "https://mydecorative.com/wp-content/uploads/2018/11/flooring-professional.jpg",
    img2: flooring2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Civil Work",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <HouseboatOutlinedIcon />,
  },
  {
    img: "https://media-exp1.licdn.com/dms/image/C4E1BAQGudwp5UHhoSQ/company-background_10000/0/1560352066991?e=2159024400&v=beta&t=i6xq6y_v5f5Zf5q9b_qxcVbO3COE5pOJiB1pHPb0vic",
    img2: mechanic2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Mechanic",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <SettingsOutlinedIcon />,
  },
  {
    img: "https://scvrepair.com/wp-content/uploads/pest-control-specialist-at-work-in-home.jpeg",
    img2: pest2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Integrated Pest Management Services",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <PestControlOutlinedIcon />,
  },

  {
    img: "https://www.industries.veolia.com/sites/g/files/dvc2561/files/styles/carousel/public/image/2016/11/VIGS-Website-Energy-1_0.jpg?h=f5bdb279&itok=WLctucxH",
    img2: water2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Utilities Management",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <FilterAltOutlinedIcon />,
  },
  {
    img: "https://localibs.co.uk/wp-content/uploads/2019/12/3-541x360.jpg",
    img2: lift2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Lift and Elevators",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <ElevatorIcon />,
  },
  {
    img: "https://apollo-doors.co.uk/wp-content/uploads/2021/03/shutterstock_178018553.jpg",
    img2: gate2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Gate Barrier System",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <FenceIcon />,
  },
  {
    img: "https://powercontrol.co.uk/wp-content/uploads/revslider/homepage/power-home-banner2.jpg",
    img2: power2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Backup and Power Supply",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <PowerIcon />,
  },
  {
    img: "https://qualityinspection.org/wp-content/uploads/2009/12/shutterstock1050266033.jpg",
    img2: quality2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Quality Control",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <FactCheckIcon />,
  },
  {
    img: "https://lifetime.co.ke/wp-content/uploads/2020/07/84709ff1-862d-.jpg",
    img2: inventory2,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "General supplies",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <InventoryIcon />,
  },
  {
    img: "https://down-to-earth-equipment-rentals.com/DownToEarthScottTownshipPA/images/equipment-rentals.jpg?v=2.0",
    img2: null,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Equipment Rental",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <HomeRepairServiceIcon />,
  },
  {
    img: "https://magenest.com/wp-content/uploads/2021/06/Public-warehouses.jpg",
    img2: null,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Warehousing",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <WarehouseIcon />,
  },
  {
    img: "https://www.mantruckandbus.com/fileadmin/_processed_/a/a/csm_MAN_18_SocialMedia_1200x628px_homepage_01_819f46e901.jpg",
    img2: null,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Transportation and rental services",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <AirportShuttleIcon />,
  },
  {
    img: "https://www.q2als.com/wp-content/uploads/2019/07/Floor-new-Q2.png",
    img2: null,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Oil field supplies",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <PlumbingIcon />,
  },
  {
    img: "https://acssmartbuildings.com/wp-content/uploads/2017/07/bigstock-engineering-automation-buildin-39420793.jpg",
    img2: null,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Building Management Services",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <ApartmentIcon />,
  },
  {
    img: "https://karmod.eu/blog/wp-content/uploads/2013/04/Oil-Field-Workforce-Housing-2.png",
    img2: null,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Camp Management",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <HolidayVillageIcon />,
  },
  {
    img: "https://www.ekathimerini.com/wp-content/uploads/2020/05/office_web-1280x720.jpg",
    img2: null,
    description2:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    title: "Building and Office Rental Service",
    description:
      "Lorem ipsum melt delor solar ipsum geru loha ispu doler arial senteu claj ajfu ameno gademo",
    icon: <BusinessIcon />,
  },
];

const carouselItems = [
  {
    id: 1,
    img: car1,
    title: "Your Reliable Partner for Facility Management",
  },
  {
    id: 2,
    img: car2,
    title: "Quality Transportation Services and Rentals",
  },
  {
    id: 3,
    img: car3,
    title: "Integrated Pest Management Services",
  },
];
export { carouselItems };
export default serviceItems;
